import React, { useState, useEffect } from "react";
import { Store } from "../Utility/Store";
import CustomICTooltip from "../Utility/Helpers/CustomICToolTip";
import { NOFOUrlGenerator } from "../Utility/Helpers/sitewide";
import InformationToolTip from "../Utility/Helpers/InformationToolTip";
import { Parser } from "html-to-react";

function DetailedDataView({
  data,
  InformationToolTipOptions,
  fullName,
  recordAction,
  date_utc_options
}) {
  const { state } = React.useContext(Store);
  const [fundingCategoryData, setFundingCategoryData] = useState([
    state.funding_category,
  ]);

  useEffect(() => {
    setFundingCategoryData(state.funding_category);
  }, [state.funding_category]);

  let acFormatted = (array) => {
    let final = [];
    if(array){
      array.map((item) => {
        let temp = item.split("/");
        final = final.concat(temp);
      });
    }
    const mySet = new Set(final);
    const uniqueArray = [...mySet];
    return uniqueArray;
  };

  let fundingCategory = (ac) => {
    let final = "";
    state.funding_category.map((category) => {
      if (category.activity_codes.includes(ac)) {
        final = category.proposed_funding_category;
      }
    });
    return final;
  };

  let fetchFundingCategory = (ac) => {
    let activity_codes = acFormatted(ac);
    let finalFundingCategory = [];
    activity_codes.map((item) => {
      if (fundingCategory(item) && fundingCategory(item) !== "") {
        finalFundingCategory.push(fundingCategory(item));
      }
    });
    const mySet = new Set(finalFundingCategory);
    const uniqueArray = [...mySet];
    return uniqueArray.join(", ");
  };

  let fundingInstrument = (ac) => {
    let final = "";
    state.funding_instrument.map((instrument) => {
      if (instrument.activity_codes.includes(ac)) {
        final = instrument.funding_instrument;
      }
    });
    return final;
  };

  let fetchFundingInstrument = (ac) => {
    let activity_codes = acFormatted(ac);
    let finalFundingInstrument = [];
    activity_codes.map((item) => {
      if (fundingInstrument(item) && fundingInstrument(item) !== "") {
        finalFundingInstrument.push(fundingInstrument(item));
      }
    });
    const mySet = new Set(finalFundingInstrument);
    const uniqueArray = [...mySet];
    return uniqueArray.join(", ");
  };

  let formatClinicalTrials = (trials) => {
    let final = [];
    if (trials.includes("Optional")) {
      final.push("Optional");
    }
    if (
      trials.includes("Required") ||
      trials.includes("Required_Infrastructure")
    ) {
      final.push("Required");
    }
    if (trials.includes("Not_Allowed")) {
      final.push("Not Allowed");
    }
    if (trials.includes("Basic_Trial")) {
      final.push("Basic Experimental Studies with Humans (BESH) Required");
    }
    return final.join(", ");
  };

  let fetchActivityCodes = (ac) => {
    let formatted = acFormatted(ac);
    let codes = [];
    formatted.map((item) => {
      let find_ac = state.activity_codes.find((c) => c.ac === item);
      if (find_ac) {
        codes.push(`${find_ac.title} (${item})`);
      } else {
        codes.push(item);
      }
    });
    return codes.join(", ");
  };

  let CareerStage = (ac) => {
    let final = "";
    state.career_stage.map((stage) => {
      if (stage.activity_codes && stage.activity_codes.includes(ac)) {
        final = stage.career_stage;
      }
    });

    switch (final) {
      case "pd_pi_undergraduate":
        final = "Undergraduate";
        break;
      case "pd_pi_graduate":
        final = "Predoctoral";
        break;
      case "pd_pi_postdoctoral":
        final = "Postdoctoral/Residency";
        break;
      case "pd_pi_early_career":
        final = "Early Career";
        break;
      case "pd_pi_established":
        final = "Established Investigator";
        break;
    }
    return final;
  };

  let fetchCareerStage = (ac) => {
    let activity_codes = acFormatted(ac);
    let finalCareerStage = [];
    activity_codes.map((item) => {
      if (CareerStage(item) && CareerStage(item) !== "") {
        finalCareerStage.push(CareerStage(item));
      }
    });
    const mySet = new Set(finalCareerStage);
    const uniqueArray = [...mySet];
    return uniqueArray.join(", ");
  };

  let Mentored = (ac) => {
    let final = "";
    state.mentored.map((mentored) => {
      if (mentored.activity_codes && mentored.activity_codes.includes(ac)) {
        final = mentored.mentored;
      }
    });
    switch (final) {
      case "Y":
        final = "Yes";
        break;
      case "N":
        final = "No";
        break;
    }
    return final;
  };

  let fetchMentored = (ac) => {
    let activity_codes = acFormatted(ac);
    let finalMentored = [];
    activity_codes.map((item) => {
      if (Mentored(item) && Mentored(item) !== "") {
        finalMentored.push(Mentored(item));
      }
    });
    const mySet = new Set(finalMentored);
    const uniqueArray = [...mySet];
    return uniqueArray.join(", ");
  };

  let PDPI = (ac) => {
    let final = "";
    state.pdpi_citizens.map((pdpi) => {
      if (pdpi.activity_codes && pdpi.activity_codes.includes(ac)) {
        final = pdpi.pd_pi_citizenship_requirement;
      }
    });
    switch (final) {
      case "Y":
        final = "Yes";
        break;
      case "N":
        final = "No";
        break;
    }
    return final;
  };

  let fetchPDPI = (ac) => {
    let activity_codes = acFormatted(ac);
    let finalPDPI = [];
    activity_codes.map((item) => {
      if (PDPI(item) && PDPI(item) !== "") {
        finalPDPI.push(PDPI(item));
      }
    });
    const mySet = new Set(finalPDPI);
    const uniqueArray = [...mySet];
    return uniqueArray.join(", ");
  };

  let reference_letters = (ac) => {
    let final = [];
    state.reference_letters.map((letter) => {
      if (letter.activity_codes && letter.activity_codes.includes(ac)) {
        final.push(letter.reference_letters_max);
      }
    });
    return final.sort();
  };

  let fetchReferenceLetters = (ac) => {
    let activity_codes = acFormatted(ac);
    let finalReference = [];
    activity_codes.map((item) => {
      finalReference = reference_letters(item);
    });
    return finalReference;
  };

  return (
    <>
      {data.map((foa, index) => {
        return (
          <div className="row mt-3">
            <div className="col-12 d-flex ">
              <div className="bg-white p-5 pe-0 w-65 rounded-start">
                <div className="border-1 border-end pe-5">
                  <div className="fs-5 mb-3">
                    {" "}
                    {foa.highlight && foa.highlight.title
                      ? Parser().parse(foa.highlight.title.join())
                      : foa._source.title}
                  </div>
                  <p>
                    <span className="fw-bold me-2">
                      Notice Number:
                      <InformationToolTip
                        content={InformationToolTipOptions.noticeNumber}
                      />
                    </span>
                    <a
                      href={NOFOUrlGenerator(foa._source.filename)}
                      onClick={() => {
                        recordAction("NOFO Click", foa._source.docnum);
                      }}
                      target="_blank"
                      rel="noreferrer"
                      className="noicon"
                    >
                      {foa._source.docnum}
                    </a>
                  </p>
                  <hr />

                  {fetchFundingInstrument(foa._source.ac).length !== 0 ? (
                    <p>
                      <span className="fw-bold me-2">
                        Funding Instrument:
                        <InformationToolTip
                          content={InformationToolTipOptions.fundingInstrument}
                        />
                      </span>
                      <span>{fetchFundingInstrument(foa._source.ac)}</span>
                    </p>
                  ) : (
                    ""
                  )}

                  {!foa._source.type.includes("nosis") &&
                  fetchFundingCategory(foa._source.ac).length !== 0 ? (
                    <p>
                      <span className="fw-bold me-2">
                        Funding Category:
                        <InformationToolTip
                          content={InformationToolTipOptions.fundingCategory}
                        />
                      </span>
                      <span>{fetchFundingCategory(foa._source.ac)}</span>
                    </p>
                  ) : (
                    ""
                  )}

                  {foa._source.ac &&
                  fetchActivityCodes(foa._source.ac).length !== 0 ? (
                    <p>
                      <span className="fw-bold me-2">
                        Activity Code:
                        <InformationToolTip
                          content={InformationToolTipOptions.activityCodes}
                        />
                      </span>
                      <span>{fetchActivityCodes(foa._source.ac)}</span>
                    </p>
                  ) : (
                    ""
                  )}

                  <p>
                    <span className="fw-bold">Purpose: </span>
                    {foa._source.purpose}
                  </p>
                  <p>
                    <span className="fw-bold me-2">
                      Issuing Organization:
                      <InformationToolTip
                        content={InformationToolTipOptions.issuingOrg}
                      />
                    </span>
                    <CustomICTooltip
                      ic={foa._source.primaryIC}
                      name={fullName(foa._source.primaryIC)}
                    />
                  </p>

                  {foa._source.sponsors &&
                  foa._source.sponsors.length > 0 &&
                  foa._source.sponsors[0] !== "none" ? (
                    <p>
                      <span className="fw-bold me-2">
                        Participating Organization(s):
                        <InformationToolTip
                          content={InformationToolTipOptions.partOrgs}
                        />
                      </span>
                      {foa._source.sponsors.map((spons, index) => {
                        return index === foa._source.sponsors.length - 1 ? (
                          <CustomICTooltip ic={spons} name={fullName(spons)} />
                        ) : (
                          <>
                            <CustomICTooltip
                              ic={spons}
                              name={fullName(spons)}
                            />
                            ,{" "}
                          </>
                        );
                      })}
                    </p>
                  ) : (
                    ""
                  )}

                  {foa._source.ApplicationType ? (
                    <p>
                      <span className="fw-bold me-2">
                        Application Types Allowed:
                        <InformationToolTip
                          content={InformationToolTipOptions.appTypesAllowed}
                        />
                      </span>
                      {foa._source.ApplicationType.join(", ")}
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="bg-white p-5 ps-4 w-35 rounded-end">
                <p>
                  <span className="fw-bold me-2">
                    Release Date:
                    <InformationToolTip
                      content={InformationToolTipOptions.releaseDate}
                    />
                  </span>

                  {foa._source.reldate
                    ? new Intl.DateTimeFormat('en-US', date_utc_options).format(new Date(foa._source.reldate))
                    : "N/A"}



                </p>
                {foa._source.expdate ? (
                  <p>
                    <span className="fw-bold me-2">
                      Expiration Date:
                      <InformationToolTip
                        content={InformationToolTipOptions.expirationDate}
                      />
                    </span>
                    {foa._source.expdate
                    ? new Intl.DateTimeFormat('en-US', date_utc_options).format(new Date(foa._source.expdate))
                    : "N/A"}
                  </p>
                ) : (
                  ""
                )}

                {!foa._source.type.includes("nosis") &&
                foa._source.clinicaltrials ? (
                  <p>
                    <span className="fw-bold me-2">
                      Clinical Trials:
                      <InformationToolTip
                        content={InformationToolTipOptions.clinicalTrials}
                      />
                    </span>
                    {formatClinicalTrials(foa._source.clinicaltrials)}
                  </p>
                ) : (
                  ""
                )}

                {!foa._source.type.includes("nosis") && foa._source.ac ? (
                  <>
                    {fetchPDPI(foa._source.ac) !== "" ? (
                      <p>
                        <span className="fw-bold me-2">
                          PD/PI US Citizenship Requirement:
                          <InformationToolTip
                            content={InformationToolTipOptions.pdpi}
                          />
                        </span>
                        <span>{fetchPDPI(foa._source.ac)}</span>
                      </p>
                    ) : (
                      ""
                    )}

                    {fetchCareerStage(foa._source.ac) !== "" ? (
                      <p>
                        <span className="fw-bold me-2">
                          Career Stage:
                          <InformationToolTip
                            content={InformationToolTipOptions.careerStage}
                          />
                        </span>
                        <span>{fetchCareerStage(foa._source.ac)}</span>
                      </p>
                    ) : (
                      ""
                    )}

                    {fetchMentored(foa._source.ac) !== "" ? (
                      <p>
                        <span className="fw-bold me-2">
                          Mentored:
                          <InformationToolTip
                            content={InformationToolTipOptions.mentored}
                          />
                        </span>

                        <span>{fetchMentored(foa._source.ac)}</span>
                      </p>
                    ) : (
                      ""
                    )}

                    {fetchReferenceLetters(foa._source.ac) &&
                    fetchReferenceLetters(foa._source.ac).length == 2 ? (
                      <p>
                        <span className="fw-bold me-2">
                          Reference Letters:
                          <InformationToolTip
                            content={InformationToolTipOptions.referenceLetters}
                          />
                        </span>
                        <span>
                          Required
                          {" ("} min {fetchReferenceLetters(foa._source.ac)[0]},
                          max {fetchReferenceLetters(foa._source.ac)[1]} {")"}
                        </span>
                      </p>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}

export default DetailedDataView;
